const mutations = {
  SET_USERNAME: "SET_USERNAME",
  SET_TOKEN: "SET_TOKEN",
  SET_TEST1: "SET_TEST1",

  SET_INVIDATA: "SET_INVIDATA",
};

export { mutations };
